<form #gridActionForm="ngForm" novalidate>
  <div class="modal-header">
    <h3 class="modal-title"><strong>{{ modalTitle }}</strong></h3>
    <div class="header-actions">
      <i
        class="fa"
        [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
        style="margin-right: 10px; cursor: pointer;"
        (click)="toggleMinimise()"
      ></i>
      <i class="fa fa-times" style="cursor: pointer;" (click)="cancel()"></i>
    </div>
  </div>

  <div class="modal-body" [hidden]="minimise">
    <div class="row action-toolbar-row">
      <div class="col-xs-5 col-md-3">
        <label>Select Grid Action</label>
        <select class="form-control input-sm" [(ngModel)]="selectedAction" name="selectedAction">
          <option [ngValue]="null">Select Grid Action</option>
          @for (item of actionList; track item) {
            <option [ngValue]="item">{{ item.name }}</option>
          }
        </select>
      </div>
      <div class="col-xs-6 col-md-4 panel-actions">
        <button type="button" class="btn btn-sm btn-success action-toolbar-btn" (click)="setType('edit')">Edit Action</button>
        <button type="button" class="btn btn-sm btn-info action-toolbar-btn" (click)="setType('new')">Create New</button>
      </div>
    </div>

    @if ((action.type === 'new' || action.type === 'edit') && !action.loading) {
      <div class="panel panel-default">
        <div class="panel-body">
          @if (action.type === 'edit') {
            <div class="row">
              <div class="gg-info" role="alert">
                <i class="fa fa-exclamation-triangle"></i>
                Filters are Column Headers will not be updated. If you would like to change either of these please delete the action and create a new one.
              </div>
            </div>
          }
          <div class="row">
            <div class="col-xs-5 col-md-3">
              <label>Action Name</label>
              <input type="text" name="action_name" required class="form-control" [(ngModel)]="action.name" placeholder="Enter Action Name">
              @if ((formSubmitted || gridActionForm.controls['action_name']?.dirty) && gridActionForm.controls['action_name']?.invalid) {
                <span class="form-error-container">
                  Please enter a name
                </span>
              }
            </div>
            <div class="col-xs-7 col-md-6">
              <label>Action Description</label>
              <textarea class="form-control action-desc-input" name="action_desc" required [(ngModel)]="action.description" rows="3"></textarea>
              @if ((formSubmitted || gridActionForm.controls['action_desc']?.dirty) && gridActionForm.controls['action_desc']?.invalid) {
                <span class="form-error-container">
                  Please enter a description
                </span>
              }
            </div>
          </div>
          @if (userAccessLevel >= 3) {
            <div class="row">
              <div class="col-xs-10 col-md-10">
                <label>System Action <i class="fa fa-info-circle"></i></label>
                <div>
                  <input type="checkbox" [checked]="action.system == 1" (change)="onSystemChange($event)">
                  * System Actions will be available to all users with access to this screen. Otherwise the action will only be available to you.
                </div>
              </div>
            </div>
          }
          @if (action.system) {
            <div class="sign-off-row">
              <div class="sign-off-col sign-off-col--checkbox">
                <label>Sign Off Required</label>
                <div>
                  <input type="checkbox" [checked]="action.sign_off == 1" (change)="onSignOffChange($event)">
                </div>
              </div>
              @if (action.sign_off == 1) {
                <div class="sign-off-col">
                  <label>Sign off Date</label>
                  <div class="input-group">
                    <input
                      id="grid_action_sign_off_date"
                      type="date"
                      class="form-control sign-off-date-input"
                      [(ngModel)]="action.signOffDate"
                      name="signOffDate"
                      >
                      <span class="input-group-addon sign-off-date-addon" (click)="openSignOffDatePicker()" title="Open calendar">
                        <i class="glyphicon glyphicon-calendar"></i>
                      </span>
                    </div>
                  </div>
                }
                @if (action.sign_off == 1) {
                  <div class="sign-off-col">
                    <label>Assign to</label>
                    <div class="input-group">
                      <input type="text" class="form-control" [(ngModel)]="action.signoffAssign" name="signoffAssign" placeholder="Enter Name or SSO">
                      <span class="input-group-addon"><i class="fa fa-user"></i></span>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
    </div>

    <div class="modal-footer" [hidden]="minimise">
      @if (action.type === 'new' || action.type === 'edit') {
        <button class="btn btn-info btn-sm" type="button" (click)="save(gridActionForm)">
          @if (action.loading) {
            <span><i class="fa fa-spinner fa-pulse"></i></span>
          }
          Save Action
        </button>
      }
      <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">Cancel</button>
      @if (action.type === 'edit') {
        <button class="btn btn-danger btn-sm" type="button" (click)="confirmDelete()">Delete</button>
      }
    </div>
  </form>

  @if (showDeleteConfirmModal) {
    <div class="confirmation-modal-overlay">
      <div class="confirmation-modal-dialog" (click)="$event.stopPropagation()">
        <gtw-confirmation-modal
          [config]="deleteConfirmConfig"
          [visible]="showDeleteConfirmModal"
          (confirmed)="onConfirmDelete(gridActionForm)"
          (cancelled)="onCancelDelete()"
          (closed)="onCancelDelete()">
        </gtw-confirmation-modal>
      </div>
    </div>
  }
